// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3GLTg","content":"RecentSearches_content__2P7P6"};